module.exports = __webpack_public_path__ + "img/icon (4).bda9bb13.png";